<template>
    <div class="d-flex flex-column align-items-center">
        <!-- Common main element parameters -->
        <div
            v-for="parameter in app.currentConfiguration
                .commonMainElementParameters"
            style="border: 0px solid black; background-color: white"
            :key="parameter.attribute.id"
            class="ml-2 mr-2 mb-4 mt-4"
        >
            <editParameterValueComponent
                ref="editParameterValueComponent"
                :labelOverInput="isMobile ? true : false"
                :parameter="parameter"
                :value.sync="parameter.value"
                @update:value="refreshParameters"
            ></editParameterValueComponent>
        </div>

        <!-- Iterate mainElements -->
        <div
            v-for="(mainElement, key, i) in app.currentConfiguration
                .mainElementParameters"
            :key="i"
            class="d-flex flex-column"
        >
            <div class="card card_size m-3">
                <!-- METROS -->
                <div
                    class="
                        card-header
                        d-flex
                        justify-content-between
                        align-items-center
                        pt-2
                        pb-2
                    "
                >
                    <editParameterValueComponent
                        :parameter="mainElement['metros_por_tramo']"
                        :value.sync="mainElement['metros_por_tramo'].value"
                        :placeholder_titel="
                            mainElement['metros_por_tramo'].attribute.name
                        "
                        :labelOverInput="false"
                        :prop_title_show="true"
                        @update:value="refreshParameters"
                    ></editParameterValueComponent>

                    <!-- REMOVE BUTTON -->
                    <button
                        v-if="i != 0"
                        :class="
                            isMobile ? 'btn_mobile_size' : 'btn_desktop_size'
                        "
                        @click.stop="removeCanal(key)"
                        class="btn btn-outline-dark btn_rounded"
                    >
                        <i
                            v-if="buttonRemoving"
                            class="fa fa-spinner fa-spin"
                        ></i>
                        <i v-else class="fas fa-minus fa-sm"></i>
                    </button>
                </div>

                <!-- OPCIONES -->
                <div
                    class="
                        card-header
                        d-flex
                        justify-content-between
                        align-items-center
                        pt-2
                        pb-2
                    "
                >
                    <div>
                        <span
                            v-show="
                                mainElement['dimensiones'].value &&
                                mainElement['opcion_compartimento'].value &&
                                mainElement['opcion_longitud'].value
                            "
                        >
                            <i
                                class="
                                    size_check_desktop
                                    fa-lg
                                    far
                                    fa-check-circle
                                    ml-1
                                    mr-3
                                "
                                style="color: black"
                            ></i>
                        </span>
                    </div>

                    <!-- GAMA -->
                    <div>
                        <span class="p-2 mr-3 font-weight-bold">
                            {{
                                app.currentConfiguration.familyParameters[
                                    "gama"
                                ].value.name
                            }}
                        </span>
                    </div>

                    <!-- CLEAN PARAMETERS -->
                    <button
                        @click.stop="cleanAllSelectors()"
                        style="
                            font-weight: lighter;
                            border-radius: 50%;
                            height: 40px;
                            width: 40px;
                            visibility: hidden;
                        "
                        class="btn btn-outline-secondary ml-2"
                    >
                        <i class="fas fa-trash-alt"></i>
                    </button>
                </div>

                <!-- SELECTORS -->
                <div
                    class="card-body d-flex flex-wrap align-items-center m-3"
                    :class="isMobile ? 'flex-column' : 'flex-row'"
                >
                    <!-- ------ -->
                    <!-- MOBILE -->
                    <!-- ------ -->
                    <img
                        v-if="isMobile"
                        :src="app.getImage(mainElement, 'dimensiones')"
                        style="height:250px; width: 250px;'"
                    />

                    <div class="d-flex flex-column">
                        <!-- opcion_longitud només vàlida per frança?? -->
                        <editParameterValueComponent
                            ref="editParameterValueComponent"
                            :labelOverInput="true"
                            :parameter="mainElement['opcion_longitud']"
                            :value.sync="mainElement['opcion_longitud'].value"
                            :field_type="'dropdown'"
                            @update:value="refreshParameters"
                            :showAllRadiobuttons="true"
                            class="mb-3"
                            :showDropdownIfOnlyOneElement="false"
                        ></editParameterValueComponent>

                        <editParameterValueComponent
                            ref="editParameterValueComponent"
                            :labelOverInput="true"
                            :parameter="mainElement['dimensiones']"
                            :value.sync="mainElement['dimensiones'].value"
                            :field_type="'radiobutton'"
                            @update:value="refreshParameters"
                            :showAllRadiobuttons="true"
                            class="mb-3"
                        ></editParameterValueComponent>
                    </div>

                    <!-- ------- -->
                    <!-- DESKTOP -->
                    <!-- ------- -->
                    <img
                        v-if="!isMobile"
                        :src="app.getImage(mainElement, 'dimensiones')"
                        class="img_size mr-5"
                    />
                    <!-- ------ -->

                    <div>
                        <editParameterValueComponent
                            ref="editParameterValueComponent"
                            :labelOverInput="true"
                            :parameter="mainElement['opcion_compartimento']"
                            :value.sync="
                                mainElement['opcion_compartimento'].value
                            "
                            :field_type="'radiobutton'"
                            @update:value="refreshParameters"
                            :showAllRadiobuttons="true"
                            class="mb-3"
                        ></editParameterValueComponent>
                    </div>
                </div>
            </div>
        </div>

        <!-- ------------- -->
        <!-- ADD BUTTON -->
        <!-- ------------- -->
        <button
            @click="addCanal()"
            class="btn btn-outline-dark btn_rounded"
            :class="isMobile ? 'btn_mobile_size' : 'btn_desktop_size'"
        >
            <i v-if="buttonLoading" class="fa fa-spinner fa-spin"></i>
            <i
                v-else
                class="fas fa-plus fa-sm"
                :class="isMobile ? 'iconMobile' : ''"
            ></i>
        </button>
    </div>
</template>

<script>
import { app } from "../../application.js";
import { Fragment } from "vue-fragment";
import editParameterValueComponent from "./../editParameterValue.vue";

export default {
    name: "mainElements73Component",
    data() {
        return {
            app: app,
            confirmBeforeLeave: true,
            parameters: [],
            mainElementDistribution: "",
            buttonLoading: false,
            buttonRemoving: false,
            labelOverDropdown: true,
            window: { width: 0, height: 0 },
        };
    },
    components: { editParameterValueComponent, Fragment },
    computed: {
        isMobile: function () {
            let a = this.window.width < 600;
            return a;
        },
    },
    methods: {
        cleanAllSelectors: function () {
            //loop through mainElementParameters values resetting all selected values in currentConfiguration.mainElementParameters
            let mainparams = this.app.currentConfiguration
                .mainElementParameters;

            Object.values(mainparams).map((mainparam) => {
                Object.values(mainparam).map((item) => {
                    if (item.value.constructor.name == "Array") {
                        item.value = [];
                    } else {
                        item.value = "";
                    }
                });
            });

            this.refreshParameters();
        },
        getParameterValueId: function (mainElement, parameter) {
            let parameter1 = mainElement[parameter];

            if (parameter1.value) return parameter1.value.id;

            return null;
        },

        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
        refreshParameters: async function () {
            await this.app.asyncProcess(false, false);
            this.app.isSpinnerAlwaysVisible = false;
        },

        isChecked: function (mainElement, compartimentos, dimension) {
            let selected_compartimentos = mainElement["opcion_compartimento"];
            let selected_dimension = mainElement["dimensiones"];
            let selected_compartimento_id = null;
            let selected_dimension_id = null;

            if (selected_compartimentos.value)
                selected_compartimento_id = selected_compartimentos.value.id;

            if (selected_dimension.value)
                selected_dimension_id = selected_dimension.value.id;

            if (selected_compartimento_id && selected_dimension_id) {
                if (
                    selected_compartimento_id == compartimentos.id &&
                    selected_dimension_id == dimension.id
                )
                    return true;
            }
        },

        onCheckChanged: async function (
            mainElement,
            compartimentos,
            dimension,
            elementKey
        ) {

            mainElement["opcion_compartimento"].value = this.getParameter(
                mainElement,
                "opcion_compartimento",
                compartimentos.id
            );
            mainElement["dimensiones"].value = this.getParameter(
                mainElement,
                "dimensiones",
                dimension.id
            );

            await this.app.asyncProcess(false, false);
        },

        getParameter: function (mainElement, parameter, id) {
            let parameterValues = mainElement[parameter].values;

            for (const value of parameterValues) {
                if (value.id === id) {
                    return value;
                }
            }

            return new Object();
        },
        addCanal: async function () {

            var self = this;

            this.buttonLoading = true
            let nomBandejaACrear = Object.keys(
                this.app.currentConfiguration.mainElementParameters).length + 1;

            await app.API.addMainElement(nomBandejaACrear);

            this.buttonLoading = false
        },
        removeCanal: async function (key) {
            var self = this;

            //------------------------------------------------------------------------------------
            //espera que Vue vacie la cola asincrónica de actualizaciones del DOM para realizar actualizaciones de DOM -> eliminar bandeja
            //------------------------------------------------------------------------------------
            this.$nextTick(async () => {

                this.buttonRemoving = true
                delete self.app.currentConfiguration.mainElementParameters[
                    key
                ];

                self.renameCanales();

                await app.asyncProcess(false, false);

                self.buttonRemoving = false
            });
            //------------------------------------------------------------------------------------
        },

        renameCanales: function () {
            let newKey = 0;
            Object.entries(
                this.app.currentConfiguration.mainElementParameters
            ).forEach(([key, value]) => {
                newKey += 1;
                if (
                    this.app.currentConfiguration.mainElementParameters.hasOwnProperty(
                        key
                    )
                ) {
                    delete this.app.currentConfiguration.mainElementParameters[
                        key
                    ];
                    this.app.currentConfiguration.mainElementParameters[
                        newKey
                    ] = value;
                }
            });
        },
    },

    created() {
        //get window size
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
    },
    destroyed() {
        //window.removeEventListener("resize", this.handleResize);
    },

    async beforeMount() {
        var self = this;
        // app.showSpinner();

        await this.refreshParameters();

        app.hideSpinner();
    },
};
</script>

<style scoped lang="scss">
.img_size {
    width: 350px;
    height: 350px;
}
</style>
